import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, HostBinding, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DividerComponent {
    constructor() {
        this.dividerClassMapping = {
            horizontal: 'pv-divider-horizontal w-full',
            vertical: 'pv-divider-vertical h-full align-self-center',
        };
        this.layoutType = 'horizontal';
        this.hostClass = '';
        this.style = {};
        this.styleClass = '';
    }
    set layout(value) {
        this.layoutType = value;
        this.hostClass = value === 'vertical' ? 'flex h-full' : 'flex w-full';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.8", type: DividerComponent, selector: "pv-divider", inputs: { style: "style", styleClass: "styleClass", layout: "layout" }, host: { properties: { "class": "this.hostClass" } }, ngImport: i0, template: `
    <hr
      class="pv-divider-container border-none border-solid {{
        this.styleClass
      }}"
      [ngClass]="this.dividerClassMapping[this.layoutType]"
      [style]="this.style" />
  `, isInline: true, styles: [".pv-divider-container{border-color:inherit;border-width:0}.pv-divider-container.pv-divider-vertical{border-right-width:thin}.pv-divider-container.pv-divider-horizontal{border-bottom-width:thin}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-divider', template: `
    <hr
      class="pv-divider-container border-none border-solid {{
        this.styleClass
      }}"
      [ngClass]="this.dividerClassMapping[this.layoutType]"
      [style]="this.style" />
  `, encapsulation: ViewEncapsulation.None, styles: [".pv-divider-container{border-color:inherit;border-width:0}.pv-divider-container.pv-divider-vertical{border-right-width:thin}.pv-divider-container.pv-divider-horizontal{border-bottom-width:thin}\n"] }]
        }], propDecorators: { hostClass: [{
                type: HostBinding,
                args: ['class']
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], layout: [{
                type: Input
            }] } });

class PvDividerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: PvDividerModule, declarations: [DividerComponent], imports: [CommonModule], exports: [DividerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvDividerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DividerComponent],
                    imports: [CommonModule],
                    exports: [DividerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DividerComponent, PvDividerModule };
